'use strict';

export const bagsize = 'size'
export const body = 'body'
export const edge = 'edge'
export const thread = 'thread'
export const inside = 'inside'
export const pocket = 'pocket'
export const side = 'side'
export const front = 'front'
export const tack = 'tack'
export const back = 'back'
export const namechar = 'namechar'
export const namethread = 'namethread'
export const noName = 'noName'

export const fullorder = 'fullorder'
export const renderingmode = 'renderingmode'

export const freeCamera = 'freecamera'
export const noStartAnimation = 'nostartanimation'
export const showfps = 'showfps'
export const postprocessing = 'postprocessing'
export const screenshot = 'screenshot'
export const stageEnvironment = 'stageEnvironment'
export const sakura = 'sakura'